(() => {
  let widgetPromise;
  const loadWidget = () => {
    if (window.YQV5?.trackSingle) return Promise.resolve();
    if (widgetPromise) return widgetPromise;
    widgetPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timeout = setTimeout(() => {
        script.remove();
        reject(new Error('Tracking widget timed out'));
      }, 15000);
      script.src = 'https://www.17track.net/externalcall.js';
      script.onload = () => {
        clearTimeout(timeout);
        if (window.YQV5?.trackSingle) resolve();
        else reject(new Error('Tracking widget unavailable'));
      };
      script.onerror = () => {
        clearTimeout(timeout);
        script.remove();
        reject(new Error('Tracking widget failed to load'));
      };
      document.head.append(script);
    }).catch(error => {
      widgetPromise = undefined;
      throw error;
    });
    return widgetPromise;
  };
  const initialize = (root = document) => {
    root.querySelectorAll('[data-tracking-page]').forEach(page => {
      const form = page.querySelector('[data-track-form]');
      if (!form || form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const field = form.querySelector('[name="tracking_number"]');
      const error = form.querySelector('[data-track-error]');
      const result = page.querySelector('[data-track-result]');
      const button = form.querySelector('[type="submit"]');
      const emptyMessage = error.textContent;
      error.setAttribute('role', 'alert');
      field.setAttribute('aria-describedby', error.id = `${field.id}-error`);
      result.setAttribute('role', 'region');
      result.setAttribute('aria-label', page.dataset.loading);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (button.disabled) return;
        const number = field.value.trim();
        error.hidden = true;
        field.removeAttribute('aria-invalid');
        if (!number) {
          error.textContent = emptyMessage;
          error.hidden = false;
          field.setAttribute('aria-invalid', 'true');
          field.focus();
          return;
        }
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        try {
          await loadWidget();
          window.YQV5.trackSingle({
            YQ_ContainerId: result.id,
            YQ_Height: 560,
            YQ_Fc: '0',
            YQ_Lang: document.documentElement.lang.split('-')[0] || 'en',
            YQ_Num: number
          });
        } catch {
          error.textContent = page.dataset.unavailable;
          error.hidden = false;
        } finally {
          button.disabled = false;
          form.removeAttribute('aria-busy');
        }
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
